export default "__VITE_ASSET__BwJPHik1__"